import React from "react";

const RefundAndCancellation = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Cancellation & Refund Policy</h1>
      <p className="text-sm text-gray-500 mb-6">Last updated on: September 20, 2025</p>

      <p className="mb-6">
        At <strong>AALADIPATTIYAN PRIVATE LIMITED</strong>, we value our customers and aim to
        provide a smooth and transparent shopping experience. Our cancellation and refund policy is
        as follows:
      </p>
     <h2 className="text-xl font-semibold mt-8 mb-4">Order Cancellations</h2>
<ul className="list-disc list-inside pl-6 space-y-2 mb-6">
  <li>
    Cancellations will be considered only if the request is made immediately after placing the
    order.
  </li>
  <li>
    Once the order has been communicated to vendors/merchants and the shipping process has
    been initiated, cancellation requests may not be entertained.
  </li>
  <li>
    Orders for perishable items (e.g., flowers, eatables) cannot be cancelled. However, a
    refund or replacement may be issued if the customer proves that the delivered product was
    of poor quality.
  </li>
</ul>


      <h2 className="text-xl font-semibold mt-8 mb-4">Damaged or Defective Items</h2>
      <ul className="list-disc list-inside pl-6 space-y-2  mb-6">
        <li>
          If you receive a damaged or defective product, please report it to our Customer Service
          team immediately.
        </li>
        <li>The request will be processed only after the merchant has verified the damage/defect.</li>
        <li>Such issues must be reported on the day of receipt of the product.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-4">Product Not as Expected</h2>
      <ul className="list-disc list-inside pl-6 space-y-2 mb-6">
        <li>
          If you feel that the product received is not as described on our website or does not meet
          your expectations, please contact our Customer Service team on the day of receipt.
        </li>
        <li>
          After reviewing your complaint, our team will take an appropriate decision regarding
          replacement or refund.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-4">Warranty Products</h2>
      <ul className="list-disc list-inside pl-6 space-y-2 mb-6">
        <li>
          For products covered under a manufacturer’s warranty, please contact the manufacturer
          directly for claims and support.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-4">Refunds</h2>
      <ul className="list-disc list-inside pl-6 space-y-2 mb-6">
        <li>
          Once approved by <strong>AALADIPATTIYAN PRIVATE LIMITED</strong>, refunds will be
          processed as per the standard banking timelines and credited to the customer’s account.
        </li>
      </ul>

      <p className="mt-8 text-sm text-gray-600 italic">
        Disclaimer: This policy is created and managed solely by{" "}
        <strong>AALADIPATTIYAN PRIVATE LIMITED</strong>. Razorpay shall not be held responsible for
        the content of this policy or for any claims or liabilities arising due to the merchant’s
        non-adherence to it.
      </p>
    </div>
  );
};

export default RefundAndCancellation;
